// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let QueryParams = require("../../reason/QueryParams.bs.js");

let config = Object.fromEntries([
  [
    "after",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ],
  [
    "before",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ],
  [
    "search",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ]
]);

let Config = {
  config: config
};

let include = QueryParams.UseQueryParams.Make(Config);

let use = include.use;

let encode = include.encode;

exports.Config = Config;
exports.use = use;
exports.encode = encode;
/* config Not a pure module */
